module.exports = __webpack_public_path__ + "static/media/Bicocca - white_Ivory.7655af15.jpg";